export default [
    {key: 'line', label: 'Linha'},
    {key: 'empresaId', label: 'EmpresaId'},
    {key: 'cpfTitular', label: 'CPF Titular'},
    {key: 'parentesco', label: 'Parentesco'},
    {key: 'nome', label: 'Nome'},
    {key: 'cpf', label: 'CPF'},
    {key: 'tipoBeneficiario', label: 'Tipo'},
    {key: 'dataNascimento', label: 'Data Nascimento'},
    {key: 'genero', label: 'Gênero'},
    {key: 'estadoCivil', label: 'Estado Civil'},
    {key: 'localTrabalho', label: 'Local de Trabalho'},
    {key: 'unidade', label: 'Unidade'},
    {key: 'cnpjFaturamento', label: 'CNPJ Faturamento'},
    {key: 'dataAdmissao', label: 'Data Admissao'},
    {key: 'endereco', label: 'Endereço'},
    {key: 'bairro', label: 'Bairro'},
    {key: 'cep', label: 'CEP'},
    {key: 'estado', label: 'Estado'},
    {key: 'cidade', label: 'Cidade'},
    {key: 'telefoneResidencial', label: 'Telefone Residencial'},
    {key: 'telefoneComercial', label: 'Telefone Comercial'},
    {key: 'telefoneCelular', label: 'Telefone Celular'},
    {key: 'email1', label: 'Email 1'},
    {key: 'email2', label: 'Email 2'},
    //{key: 'matricula', label: 'Matrícula'},
    {key: 'ghe', label: 'GHE'},
    {key: 'setor', label: 'Setor'},
    {key: 'funcao', label: 'Função'}
]
